<body class="A4">
  <!-- Each sheet element should have the class "sheet" -->
  <!-- "padding-**mm" is optional: you can set 10, 15, 20 or 25 -->
  <section class="sheet padding-10mm">
    <div class="logo d-flex align-items-center">
      <img [src]="logoImage"/>
    </div>
    <div class="influencer-basic-info">
      <app-influencer-basic-information
        *ngIf="influencer"
        [influencer]="influencer"
        [showCountryFlagIcon]="true">
      </app-influencer-basic-information>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <section class="sheet padding-10mm">
    <div class="post-list">
      <div class="d-flex flex-row pdf-header">
        <div class="content-header pdf-content-header">{{ 'INFLUENCER.OVERVIEW' | translate }}</div>
        <div class="d-flex flex-column rigth-content-header">
          <div class="d-flex flex-g1 justify-content-end align-items-center">
            <div class="date">{{previousDate| date:'MMM dd, yyyy'}} - {{currentDate | date:'MMM dd, yyyy'}}</div>
          </div>
        </div>
      </div>
      <app-post-list *ngIf="influencerPostList"
        [postList]="influencerPostList"
        [influencerGroupId]="groupId"
        [previewMode]="true"
        [columnWidth]="166"
        [gutter]="0">
      </app-post-list>
    </div>
    <div class="top-mention">
      <top-mention *ngIf="topMention" [data]="topMention"></top-mention>
    </div>
    <div class="row topic-chart-container">
      <div class="col-sm-6 popular-topic-chart-container border-right">
        <achoo-pie-chart *ngIf="isVisibleTopicChart"
          [chartData]="popularTopic"
          [chartTitle]="'INFLUENCER.CHART.POPULAR_TOPICS' | translate"
          [height]="pieChartHeight"
          [pieCenter]="pieChartCenter"
          [titleStyling]="pieChartTitleStyling"
          [pieSize]="pieChartSize"
          [pieInnerSize]="pieChartInnerSize"
          [legend]="pieChartLegend">
        </achoo-pie-chart>
      </div>
      <div class="col-sm-6 topic-engagement-chart-container">
        <achoo-column-chart *ngIf="isVisibleTopicChart"
          [chartData]="topicAndEngagementChart"
          [chartTitle]="'INFLUENCER.CHART.TOPIC_VS_ENGAGEMENT' | translate"
          [titleStyling]="{fontSize: '0.85rem'}"
          [chartCustomConfig]="{fontSize: 10, pointWidth: 14}"
          [height]="215">
        </achoo-column-chart>
      </div>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <section class="sheet padding-10mm">
    <div class="d-flex flex-row pdf-header">
      <div class="content-header pdf-content-header">{{ 'INFLUENCER.ACTIVITY' | translate }}</div>
      <div class="d-flex flex-column rigth-content-header">
        <div class="d-flex flex-g1 justify-content-end align-items-center">
          <div class="date">{{previousDate| date:'MMM dd, yyyy'}} - {{currentDate | date:'MMM dd, yyyy'}}</div>
        </div>
      </div>
    </div>
    <div class="activity-chart">
      <div class="activity-title">
        <span>{{'INFLUENCER.insight.activity_chart.title' | translate}}</span>
      </div>
      <div class="activity-line-chart-body" *ngIf="influencerActivityLineChartData">
        <achoo-line-chart [chartData]="influencerActivityLineChartData"
                          [legendXPosition]="1"
                          [legendYPosition]="-2"
                          [legendItemDistance]="-3"
                          [xLabelPaddingTop]="15"
                          [spacingBottom]="10">
        </achoo-line-chart>
      </div>
    </div>
    <div class="kpi-report-container">
      <new-kpi *ngIf="influencerKPIData" [kpi]="influencerKPIData"></new-kpi>
    </div>
    <div class="platform-reache-circle" *ngIf="!activeChannel">
      <platform-reache *ngIf="platformReachs"
                       [platforms]="platformReachs"
                       [activePlatforms]="getSupportedPlatformReachIdList(platformReachs)">
      </platform-reache>
    </div>
    <div class="channel-followers-container" *ngIf="isEnableChannelFollowers && channelFollowersData.length > 0">
      <div class="d-flex flex-row channel-followers-header">
        <div class="title">{{'INFLUENCER.insight.channel_followers_title' | translate}}</div>
      </div>
      <div class="d-flex flex-column follower-chart-mobile">
        <div class="chart-content">
          <channel-followers [channelFollowersData]="channelFollowersData"></channel-followers>
        </div>
      </div>
    </div>
    <div class="top-exposures-container">
      <div class="influencer-section">
        <div class="header top-exposures">
          <span>{{'INFLUENCER.insight.top_exposure.title' | translate}}</span>
        </div>
        <top-exposures *ngIf="topExposures"
                        [platformList]="platformList"
                        [topExposures]="topExposures" >
        </top-exposures>
      </div>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <section class="sheet padding-10mm">
    <div class="d-flex flex-row pdf-header">
      <div class="content-header pdf-content-header">{{ 'INFLUENCER.ACTIVITY' | translate }}</div>
      <div class="d-flex flex-column rigth-content-header">
        <div class="d-flex flex-g1 justify-content-end align-items-center">
          <div class="date">{{previousDate| date:'MMM dd, yyyy'}} - {{currentDate | date:'MMM dd, yyyy'}}</div>
        </div>
      </div>
    </div>
    <div class="best-performing-exposure-container">
      <div class="influencer-section d-flex flex-column">
        <div class="header">
          <span>{{'INFLUENCER.insight.platform_reach.title' | translate}}</span>
        </div>
        <div class="chart-content">
          <list-platform-reach *ngIf="listPlatformReach" [platformReachs]="listPlatformReach"></list-platform-reach>
        </div>
      </div>
    </div>
    <div class="best-performing-exposure-container">
      <div class="influencer-section d-flex flex-column">
        <div class="header">
          <span>{{'INFLUENCER.insight.best_performing_exposure.title' | translate}}</span>
        </div>
        <div class="chart-content">
          <best-performing-exposure *ngIf="bestPerformingExposures" [bestPerformingExposures]="bestPerformingExposures" >
          </best-performing-exposure>
        </div>
      </div>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <section class="sheet dynamic-height padding-10mm">
    <div class="d-flex flex-row pdf-header">
      <div class="content-header pdf-content-header">{{ 'INFLUENCER.DEMOGRAPHICS' | translate }}</div>
      <div class="d-flex flex-column rigth-content-header">
        <div class="d-flex flex-g1 justify-content-end align-items-center">
          <div class="date">{{previousDate| date:'MMM dd, yyyy'}} - {{currentDate | date:'MMM dd, yyyy'}}</div>
        </div>
        <div class="d-flex flex-row justify-content-end dm-source-selection-container selected-source-container">
          <div class="source-name-wrapper selected-source-name">{{selectedDemographicSource.name}}</div>
          <div class="source-platform-image {{selectedDemographicSource.platformName}}-icon selected-source-icon"></div>
        </div>
      </div>
    </div>
    <demographic-page *ngIf="influencerId"
      #Demographics
      [demoInfluencerId]="influencerId"
      [pieHeight]="pieChartHeight"
      [pieCenter]="pieChartCenter"
      [pieSize]="pieChartSize"
      [pieInnerSize]="pieChartInnerSize"
      [pieTitleStyling]="pieChartTitleStyling"
      [pieLegend]="pieChartLegend"
      [printMode]="true"
      (emitSelectedDemographicSource)="getSelectedDemographicSource($event)">
    </demographic-page>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <section class="sheet padding-10mm"></section>
</body>



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/influencer-detail-pdf-viewer/influencer-detail-pdf-viewer.component.html